import Vue from "vue";
import Vuex from "vuex";

// Modules
import users from "./modules/users";
import auth from "./modules/auth";
import patients from "./modules/patients";
import projects from "./modules/projects";
import colors from "./modules/colors";
import articles from "./modules/articles";
import dropdowns from "./modules/dropdowns";
import minerva from "./modules/products/minerva";
import moldedSeat from "./modules/products/moldedSeat";
import otn from "./modules/products/otn";
import lift from "./modules/products/lift";
import retouchingRepair from "./modules/products/retouching_repair";
import seat from "./modules/products/seat";
import positioningSeat from "./modules/products/postitioningSeat";
import upperLimb from "./modules/products/upperLimb";
import corset from "./modules/products/corset";
import lowerLimb from "./modules/products/lowerLimb";

import notifications from "./modules/notifications";
import medias from "./modules/medias";

import cache from "./plugins/cache";

import { overrideLog } from "../override-log";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    notifications,
    medias,
    auth: auth,
    patients: patients,
    projects: projects,
    users: users,
    colors: colors,
    articles: articles,
    dropdowns: dropdowns,

    // Products
    minerva,
    moldedSeat,
    otn,
    lift,
    retouchingRepair,
    seat,
    positioningSeat,
    upperLimb,
    corset,
    lowerLimb
  },
  state: {
    // Todo: Rework this to medias
    mediaContainerWidth: 700,
    mediaRation: 1.333333333333333,

    initialized: false,
    isOnline: true,
    showSnackbar: false,
    colorSnackbar: "success",
    textSnackbar: "",

    // Logs
    logs: [''],
    logging: false,
    originalConsoleLog: console.log
  },
  mutations: {
    // Remove this useless
    LOAD_FROM_CACHE(state, cached) {
      if (cached) {
        Object.keys(cached).forEach(key => {
          state[key] = Object.assign({}, state[key], cached[key]);
        });
      }

      state.initialized = true;
    },

    ENABLE_LOGGING(state) {
      overrideLog(this)
      state.logging = true
      console.log('Logging enabled!');
    },

    DISABLE_LOGGING(state) {
      console.log = state.originalConsoleLog
      state.logging = false
      console.log('Logging disabled!');
    },

    APPEND_LOG(state, log) {
      state.logs.push(log)
    },

    CLEAR_LOGS(state) {state.logs = ['']},

    // Set api version
    setConnectionStatus(state, payload) {
      state.isOnline = payload;
    },

    // Set snackbar
    setSnackbar(state, { show, color, text }) {
      state.colorSnackbar = color;
      state.textSnackbar = text;
      state.showSnackbar = show;
    }
  },
  actions: {
    // Gets all we need
    async getAll({ dispatch }) {
      await dispatch("users/getUsers");
      await dispatch("colors/fetchColors");
      await dispatch("articles/getArticles");
      await dispatch("dropdowns/getDropdowns");
    },

    // Clean all store
    async cleanAll({ dispatch }) {
      await dispatch("patients/clean");
      await dispatch("articles/cleanArticles");
    },

    appendLog({commit}, opts) { 
      commit("APPEND_LOG", opts.log)
    },

    toggleLogging({state, commit}) {
      state.logging ? commit('DISABLE_LOGGING') : commit('ENABLE_LOGGING')
    },

    clearLogs({commit}) {
      commit('CLEAR_LOGS')
    }
  },

  plugins: [cache]
});
